export default {
  // eslint-disable-next-line
  getActiveIntegrationConfig: state => state.availableIntegrations === '' ? '' : state.availableIntegrations[Object.keys(state.availableIntegrations).find(key => state.availableIntegrations[key].name === state.integrationHeader)],
  getCPC: state => state.cpc,
  getNotificationsNames: state => state.notificationsNames,
  getRefUrl: state => state.refUrl,
  getClickId: state => state.clickid,
  getCampaignId: state => state.campaignId,
  getPublisherId: state => state.publisherId,
  getInviteReferral: state => state.inviteReferral,
  getTwoStepsRegistration: state => state.twoStepRegistration,
  getUserAvailableGames: state => state.userDetails.availableGames,
  getSimpleRegistration: state => state.simpleRegistration,
  getAvailableFlowsInfo: state => state.availableFlows,
  getCorrelationId: state => state.correlationId,
  existThisPathInForbiddenPages: state => path => state.availableFlows[state.simpleRegistration].blockedRoutes.includes(path),
  getAvailableIntegrations: state => state.availableIntegrations,
  getIntegrationConfig: state => state.integrationConfig,
  isRegistrationViaSms: state => [
    state.availableIntegrations.ROSHAN.name
  ].includes(state.integrationConfig.integrationKey),
  getActiveModal: state => state.activeModals[state.activeModals.length - 1],
  getMessagingConfig: state => state.messaging,
  getPushNotificationsPublicKey: state => state.pushNotificationsPublicKey,
  getInstallPromptEvent: state => state.installPromptEvent,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/getters.js